/* eslint-disable no-use-before-define */
import React from "react";
import { useNavigate } from "react-router-dom";
import nexumLogo from "../../assets/nexumLogo.png";
import Navbar from "../../shared/components/navbar";
import Sidebar from "../../shared/components/sidebar";
import Button from "../../shared/components/button/button";
import MainLayout from "../../shared/components/MainLayout";
import { motion } from "framer-motion";
import Button2 from "../../shared/components/button/Button2";
import { AlertTriangle, Package2 } from "lucide-react";

const CancelPage: React.FC = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/private/productlistV3/");
  };

  return (
    <MainLayout>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-4xl mx-auto">
          <motion.div 
            className="bg-white rounded-2xl shadow-xl overflow-hidden"
            whileHover={{ scale: 1.01 }}
            transition={{ duration: 0.2 }}
          >
            <div className="grid md:grid-cols-2 grid-cols-1 min-h-[450px]">
              {/* Left Side - Logo */}
              <div className="p-8 bg-gradient-to-br from-sky-200 to-white flex items-center justify-center ">
                <img
                  className="max-w-[200px] w-full"
                  src={nexumLogo}
                  alt="nexumLogo"
                />
              </div>
              <div className="login-right">
                <div className="login-right-wrap p-4 text-center pt-8">
                  <div className="flex flex-col items-center justify-center mt-4 mb-6">
                    <AlertTriangle className="w-24 h-24 text-red-500" />
                  </div>
                  <h1 className="text-2xl font-bold text-gray-900 ">The payment has not been successful</h1>
                  <p className="account-subtitle mt-4 text-gray-400">
                    Please check your data
                  </p>
                  <p className="text-gray-400 mt-4">
                    If you have any questions, please contact us at <a href="mailto:info@nexum.it" className="text-blue-500">info@nexum.it</a>
                  </p>
                  <Button2
                    title="Go to Product"
                    onClick={handleButtonClick}
                    icon={Package2}
                    className="w-full mt-6 py-3"
                    iconPosition="left"
                  />
                </div>
              </div>
            </div>
          </motion.div>
          </div>
        </motion.div>
    </MainLayout>
  );
  };

export default CancelPage;
